import { render } from "./IconBookOutline.vue?vue&type=template&id=1b1f378c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBookOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b1f378c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b1f378c', __exports__)) {
    api.reload('1b1f378c', __exports__)
  }
  
  module.hot.accept("./IconBookOutline.vue?vue&type=template&id=1b1f378c", () => {
    api.rerender('1b1f378c', render)
  })

}


export default __exports__